import { observable } from 'mobx'
import { Permissions } from '@/features/iam/permissions/Permissions'
import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'
import { once } from 'lodash-es'

export type TeamRoleProps = ModelProps<TeamRole>

export class TeamRole extends Model<TeamRole> {
  @observable accessor name = ''
  @observable accessor isOwnerRole = false
  @observable accessor description = ''
  @observable accessor permissions = Permissions.empty()
  @observable accessor workspaceId = Id.none
  @observable accessor dateCreated: Date = unixEpoch()
  @observable accessor dateModified: Date = unixEpoch()
  id = Id.none

  static get none() {
    return lazyNone()
  }
}

const lazyNone = once(() =>
  new TeamRole().set({
    name: 'None',
  }),
)
